import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Dialog } from '@shared/ui-react/Dialog';
import * as React from 'react';
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { Button } from '@shared/ui-react/Button';
import { Notify } from '@shared/ui-native/Notify';
import { Ajax2 } from "@shared/Ajax";
import { GeofenceType } from '@shared/trucks/GeofenceFeatureFactory';
import { GeofencesStore } from '@pages/trucks/store/GeofencesStore';


export const DeleteGeofenceDialog = {
    open: (geofenceStore: GeofencesStore, geofenceId: number, usedInTrips: boolean, onSuccess: Function) => {
        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(
            <Dialog onClose={DeleteGeofenceDialog.close} title={__('trucks.geofence.delete_area')}>
                <DeleteGeofenceComponent
                    geofenceStore={geofenceStore}
                    geofenceId={geofenceId}
                    usedInTrips={usedInTrips}
                    onSuccess={onSuccess}/>
            </Dialog>, targetEl);
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    }
};


@observer
class DeleteGeofenceComponent extends React.Component<{
    geofenceStore: GeofencesStore,
    geofenceId: number,
    usedInTrips: boolean,
    onSuccess: Function
}, {}> {
    @observable isRunning = false;
    @observable sourceGeofenceType = null;
    @observable destinationGeofenceId = null;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.sourceGeofenceType = this.props.geofenceStore.items.find(g => g.id === this.props.geofenceId).type;
        this.destinationGeofenceId = this.props.geofenceStore.items.find(g => g.id !== this.props.geofenceId && g.type === this.sourceGeofenceType)?.id;
    }

    render() {
        const source = this.props.geofenceStore.items.find(m => m.id === this.props.geofenceId);
        const geofences = this.props.geofenceStore.items.filter(m => m.id !== this.props.geofenceId && (m.type === GeofenceType.HYBRID || m.type === this.sourceGeofenceType));
        if (!source) return null;

        return (
            <>
                <div className="padded" style={{ width: 400 }}>
                    {this.props.usedInTrips ?
                        <>
                            <div>{__('trucks.geofence.marge_and_delete_area_explain', source.title)}:</div>
                            <select value={this.destinationGeofenceId}
                                    onChange={e => this.destinationGeofenceId = parseInt(e.currentTarget.value)}
                                    style={{ fontSize: 15, padding: '5px 10px', width: '100%', height: 'auto', marginTop: 20 }}>
                                {geofences.map(m => <option key={m.id} value={m.id}>{m.title}</option>)}
                            </select>
                        </> : <div>
                            {__('trucks.geofence.delete_area_unassigned', source.title)}
                        </div>}
                </div>

                <footer className="infrakit-dialog__footer" style={{ justifyContent: 'space-between' }}>
                    <Button onClick={DeleteGeofenceDialog.close} className="ik-button-secondary--subtle">{__('general.close')}</Button>
                    <Button onClick={this.props.usedInTrips ? this.mergeAndDeleteArea : this.deleteArea} loading={this.isRunning}
                            className="btn-danger">{__(this.props.usedInTrips ? 'trucks.geofence.merge' : 'general.delete')}</Button>
                </footer>
            </>
        );
    }

    mergeAndDeleteArea = () => {
        this.isRunning = true;
        Ajax2({
            url: `${kuura.getContextPath()}/masshaul_area/merge?areaId=${this.props.geofenceId}&newAreaId=${this.destinationGeofenceId}`,
            method: 'POST',
            contentType: 'json'
        }).then(() => {
            this.props.onSuccess();
            Notify.success();
            DeleteGeofenceDialog.close();
        }).catch(() => {
            Notify.error();
        }).finally(() => {
            this.isRunning = false;
        });
    }

    deleteArea = () => {
        this.isRunning = true;
        Ajax2({
            url: `${kuura.getContextPath()}/remove_project_masshaul_area.json`,
            method: 'GET',
            contentType: 'json',
            data: {
                areaId: this.props.geofenceId,
                projectId: kuura.getProjectId()
            }
        }).then(() => {
            this.props.onSuccess();
            Notify.success();
            DeleteGeofenceDialog.close();
        }).catch(() => {
            Notify.error();
        }).finally(() => {
            this.isRunning = false;
        });
    }
}
